// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var normalizeCss = function (css) {
    if (typeof css !== "string") {
        return null;
    }
    var trimmed = css.trim();
    return trimmed.length ? css : null;
};
export var manifestCustomCss = function (manifest, electionId) {
    var _a, _b, _c;
    var eventCss = normalizeCss((_a = manifest === null || manifest === void 0 ? void 0 : manifest.custom_css) === null || _a === void 0 ? void 0 : _a.election_event);
    var electionCss = electionId
        ? normalizeCss((_c = (_b = manifest === null || manifest === void 0 ? void 0 : manifest.custom_css) === null || _b === void 0 ? void 0 : _b.elections) === null || _c === void 0 ? void 0 : _c[electionId])
        : null;
    return [eventCss, electionCss].filter(Boolean).join("\n");
};
